import {createApp} from 'vue'
import options from './MenuPrimary.options'
import { useMainStore } from 'stores/main.store'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const scrapeMenuForLinkData = function(MenuPrimaryDOM){

    const megaMenusDOM = MenuPrimaryDOM.querySelectorAll('.be-menu-primary__mega-menu')

    const megaMenuData = Array.from(megaMenusDOM).reduce((completeData,currentMegaMenuDOM,order)=>{

        const menuData =  {[currentMegaMenuDOM.getAttribute('id')]: {
            order,
            links : Array.from(currentMegaMenuDOM.querySelectorAll('a')).reduce((allLinks,linkDOM)=>{
                allLinks.push({
                    href: linkDOM.href,
                    displayName: linkDOM.classList.contains('be-menu-primary__mega-menu-featured-link') 
                        ? linkDOM.querySelector('.be-menu-primary__mega-menu-featured-link-text').textContent.trim() 
                        : linkDOM.textContent.trim(),
                    toplevel: linkDOM.parentNode.classList.contains('be-menu-primary__mega-menu-list-item--top'),
                    type: linkDOM.classList.contains('be-menu-primary__mega-menu-featured-link') 
                        ? 'featured' 
                        : 'regular'
                })

                return allLinks
            },[])
        } } 
        
        return Object.assign(menuData,completeData)
    },{})

    // the cta button needs to be handled seperately
    MenuPrimaryDOM.querySelectorAll('.be-js-cta-button').forEach((ctaButton)=>{
        megaMenuData.ctaButton = {
            href: ctaButton.href,
            displayName: ctaButton.textContent.trim()
        }
    })

    MenuPrimaryDOM.querySelectorAll('.be-menu-primary__menu-list-item button').forEach((currentMegaMenuPrimaryButton)=>{
        const id = currentMegaMenuPrimaryButton.dataset.menu
        if(id) megaMenuData[id].displayName = currentMegaMenuPrimaryButton.textContent.trim()
    })

    // initializing the property to avoid runtime errors
    megaMenuData.actionsDisplayNames = {}

    MenuPrimaryDOM.querySelectorAll('[data-action]').forEach((action)=>{
        megaMenuData.actionsDisplayNames[action.dataset.action] = {
            name: action.textContent.trim(),
            href: action.href ?? action.dataset.href ?? null 
        }
    })

    return megaMenuData
}


const el = '.be-component--menu-primary'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((MenuPrimaryDOM) => {
            const template = MenuPrimaryDOM.innerHTML
            options.template = template
            const component = createApp(options).use(Store)
            
            const mainStore = useMainStore()
            mainStore.setPrimaryMenuMobileData(scrapeMenuForLinkData(MenuPrimaryDOM))

            component.mount(MenuPrimaryDOM)
        })
    }
}

